import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { TipoRespaldoService } from '../../_services/tipo-respaldo.service';
import { TipoRespaldoCategoriaService } from '../../_services/tipo-respaldo-categoria.service';
import { TipoRespaldo } from '../../_models/tipo-respaldo';
import { TipoRespaldoCategoria } from '../../_models/tipo-respaldo-categoria';
import { TipoRespaldoSubcategoria } from '../../_models/tipo-respaldo-subcategoria';

@Component( {
  selector: 'app-tipo-respaldo-categoria',
  templateUrl: 'tipo-respaldo-categoria.component.html'
} )

export class TipoRespaldoCategoriaComponent implements OnInit {

  @Input() tipoRespaldo: TipoRespaldo;
  @Output() respaldoCategoriaEvent: EventEmitter<TipoRespaldoCategoria> = new EventEmitter();
  @Output() tabEvent: EventEmitter<string> = new EventEmitter();
  respaldoCategoria: TipoRespaldoCategoria;
  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  lisTipoRespaldoCategoria: TipoRespaldoCategoria[] = [];
  formulario: FormGroup;
  submitted = false;
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private serTipoRespaldo: TipoRespaldoService,
               private serTipoRespaldoCategoria: TipoRespaldoCategoriaService,
               private navServicio: NavService,
               private route: ActivatedRoute,
               private location: Location,
               private fb: FormBuilder,
               private autServicio: AutenticacionService,
               private conServicio: ConfirmationService,
               private router: Router ) {
  }

  ngOnInit(): void {
    if ( this.tipoRespaldo && (this.tipoRespaldo.idTipoRespaldo !== '' && this.tipoRespaldo.idTipoRespaldo !== null && this.tipoRespaldo.idTipoRespaldo !== undefined) ) {
      /** Se traen todos los seguros planes que pertenezcan al seguro actual */
      this.serTipoRespaldoCategoria.listadoPorIdRespaldo( this.tipoRespaldo.idTipoRespaldo ).subscribe( tipoRespaldoCategoria => {
        this.lisTipoRespaldoCategoria = tipoRespaldoCategoria;
        this.carServiciosIniciales();
      } );
    }
  }

  carServiciosIniciales() {

    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/tipo-respaldo-categoria' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_NOMCAT' ), sort: true },
      { field: 'indicadorNegocio', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_INDINEGOCIO' ), sort: true },
      { field: 'adjunto', header: this.navServicio.buscarMensaje( 'LBL_ADJUNTO' ), sort: true },
      { field: 'habilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.formulario = this.fb.group( {
      idTipoRespaldoCategoria: [ this.respaldoCategoria ? this.respaldoCategoria.idTipoRespaldoCategoria : null ],
      idTipoRespaldo: [ this.tipoRespaldo.idTipoRespaldo, [ Validators.required ] ],
      codigo: [ this.respaldoCategoria ? this.respaldoCategoria.codigo : null, [ Validators.required ] ],
      nombre: [ this.respaldoCategoria ? this.respaldoCategoria.nombre : null, [ Validators.required ] ],
      indicadorSubcategoria: [ this.respaldoCategoria ? this.respaldoCategoria.indicadorSubcategoria : false, [ Validators.required ] ],
      indicadorNegocio: [ this.respaldoCategoria ? this.respaldoCategoria.indicadorNegocio : false, [ Validators.required ] ],
      indicadorManejaAdjunto: [ this.respaldoCategoria ? this.respaldoCategoria.indicadorManejaAdjunto : false, [ Validators.required ] ],
      indicadorHabilitado: [ this.respaldoCategoria ? this.respaldoCategoria.indicadorHabilitado : true, [ Validators.required ] ],
    } );

    this.busqueda = this.navServicio.getSearch( 'tipo-respaldo.component' );
    this.carTabla = false;
    this.carInformacionInicial = false;
  }


  onSubmit() {
    this.submitted = true;
    if ( !this.codExiste && this.formulario.valid ) {
      this.guardando = true;
      this.carTabla = true;
      const formulario = this.formulario.getRawValue();
      if ( this.respaldoCategoria && (this.respaldoCategoria.idTipoRespaldoCategoria !== '' && this.respaldoCategoria.idTipoRespaldoCategoria !== null && this.respaldoCategoria.idTipoRespaldoCategoria !== undefined) ) {
        /** Se actualiza la categoría */
        this.serTipoRespaldoCategoria.actualizar( formulario ).subscribe( tipoRespaldoCategoria => {
          this.lisTipoRespaldoCategoria = [];
          this.serTipoRespaldoCategoria.listadoPorIdRespaldo( this.tipoRespaldo.idTipoRespaldo ).subscribe( lisRespaldoCategoria => {
            this.lisTipoRespaldoCategoria = lisRespaldoCategoria;
            this.guardando = false;
            this.submitted = false;
            this.codExiste = false;
            this.carTabla = false;
            this.respaldoCategoria = null;
            this.formulario.reset();
            this.f.idTipoRespaldo.setValue( this.tipoRespaldo.idTipoRespaldo );
            this.f.indicadorHabilitado.setValue( true );
            this.f.indicadorManejaAdjunto.setValue( false );
            this.f.indicadorNegocio.setValue( false );
            this.f.indicadorSubcategoria.setValue( false );
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_ACTUALIZO' )
            } );
          } );
        } );
      } else {
        /** Se crea la categoría */
        this.serTipoRespaldoCategoria.crear( formulario ).subscribe( tipoRespaldoCategoria => {
          this.lisTipoRespaldoCategoria = [];
          this.serTipoRespaldoCategoria.listadoPorIdRespaldo( this.tipoRespaldo.idTipoRespaldo ).subscribe( lisRespaldoCategoria => {
            this.lisTipoRespaldoCategoria = lisRespaldoCategoria;
            this.guardando = false;
            this.submitted = false;
            this.codExiste = false;
            this.carTabla = false;
            this.respaldoCategoria = null;
            this.formulario.reset();
            this.f.idTipoRespaldo.setValue( this.tipoRespaldo.idTipoRespaldo );
            this.f.indicadorHabilitado.setValue( true );
            this.f.indicadorManejaAdjunto.setValue( false );
            this.f.indicadorNegocio.setValue( false );
            this.f.indicadorSubcategoria.setValue( false );
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_CREO' )
            } );
          } );
        } );
      }

    } else {
      if ( this.codExiste ) {
        this.navServicio.setMesage( 0, {
          severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_ERRORCODCAT' )
        } );
      }
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }


  validarCodigo() {
    this.codExiste = this.lisTipoRespaldoCategoria.find( x => x.codigo === this.f.codigo.value ) ? true : false;
  }

  get f() {
    return this.formulario.controls;
  }

  setBusqueda() {
    this.navServicio.setSearch( 'tipo-respaldo-categoria.component', this.busqueda );
  }

  visualizar( tipoRespaldo: TipoRespaldoCategoria ) {
    this.router.navigate( [ 'apl/tipo-respaldo/detalle/' + tipoRespaldo.idTipoRespaldo ] );
  }


  editar( tipoRespaldo: TipoRespaldoCategoria ) {
    this.respaldoCategoria = tipoRespaldo;
    this.formulario.reset();
    this.f.idTipoRespaldoCategoria.setValue( this.respaldoCategoria.idTipoRespaldoCategoria );
    this.f.idTipoRespaldo.setValue( this.respaldoCategoria.idTipoRespaldo );
    this.f.codigo.setValue( this.respaldoCategoria.codigo );
    this.f.nombre.setValue( this.respaldoCategoria.nombre );
    this.f.indicadorSubcategoria.setValue( this.respaldoCategoria.indicadorSubcategoria );
    this.f.indicadorNegocio.setValue( this.respaldoCategoria.indicadorNegocio );
    this.f.indicadorHabilitado.setValue( this.respaldoCategoria.indicadorHabilitado );
    this.f.indicadorManejaAdjunto.setValue( this.respaldoCategoria.indicadorManejaAdjunto );
  }

  agregarSubcategoria( tipoRespaldo: TipoRespaldoCategoria ) {
    this.respaldoCategoriaEvent.emit( tipoRespaldo );
    this.tabEvent.emit( 'SUBC' );
  }

  habilitar( item: TipoRespaldoCategoria, control:boolean ) {
    if ( !control ) {
      this.validarIndicadorManejaAdjunto(item.indicadorManejaAdjunto, item.indicadorSubcategoria)
    }
    if ( item.indicadorNegocio && control || item.indicadorManejaAdjunto && !control) {
      this.carTabla = true;
      this.serTipoRespaldoCategoria.actualizar( item ).subscribe( regActualizado => {
        this.lisTipoRespaldoCategoria.map( ( s: TipoRespaldoCategoria ) => {
          if ( s.idTipoRespaldoCategoria === regActualizado.idTipoRespaldoCategoria ) {
            control ?
            s.indicadorNegocio = regActualizado.indicadorNegocio
            : s.indicadorManejaAdjunto = regActualizado.indicadorManejaAdjunto;
          }
        } );
        this.carTabla = false;
      } );
    }else {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_CONFIRINHABILITAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        key: 'categoria',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.carTabla = true;
          this.serTipoRespaldoCategoria.actualizar( item ).subscribe( regActualizado => {
            this.lisTipoRespaldoCategoria.map( ( s: TipoRespaldoCategoria ) => {
              if ( s.idTipoRespaldoCategoria === regActualizado.idTipoRespaldoCategoria ) {
                control ?
                s.indicadorNegocio = regActualizado.indicadorNegocio
                : s.indicadorManejaAdjunto = regActualizado.indicadorManejaAdjunto;
              }
            } );
            this.carTabla = false;
          } );
        },
        reject: () => {
          this.lisTipoRespaldoCategoria.map( ( s: TipoRespaldoCategoria ) => {
            if ( s.idTipoRespaldoCategoria === item.idTipoRespaldoCategoria ) {
              control ?
              s.indicadorNegocio = !item.indicadorNegocio
              : s.indicadorManejaAdjunto = !item.indicadorManejaAdjunto;
            }
          } );
        }
      } );
    }
  }

  validarIndicadorManejaAdjunto(indicadorManejaAdjunto: boolean, indicadorSubcategoria: boolean) {
    if (indicadorSubcategoria) {
      if (indicadorManejaAdjunto) {
        this.navServicio.setMesageToast(
          {
            key: 'toastMessage',
            severity: "info",
            life: 10000,
            summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_ADJUNTOHABILITADO' )
          }
        );
      } else {
        this.navServicio.setMesageToast(
          {
            key: 'toastMessage',
            severity: "info",
            life: 10000,
            summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_ADJUNTOINHABILITADO' )
          }
        );
      }
    }
  }
}
